import { observable } from 'mobx'

class Klient {

    constructor() {
        this.id = -1;
        this.jmeno = "";
        this.prijmeni = "";
        this.telefon = "";
        this.email = "";
        this.ulice = "";
        this.mesto = "";
        this.poznamka = "";
        this.PSC = "";
        this.stridavyRozvoz = "";
        this.nahradniAdresa = "";
        this.trasa = "";
    }

    @observable public id: number;
    @observable public jmeno: string;
    @observable public prijmeni: string;
    @observable public telefon: string;
    @observable public email: string;
    @observable public ulice: string;
    @observable public mesto: string;
    @observable public poznamka: string;
    @observable public PSC: string;
    @observable public stridavyRozvoz: string;
    @observable public nahradniAdresa: string;
    @observable public trasa: string;

    public clone(): Klient {
        const newKlient: Klient = new Klient();
        newKlient.loadFromEntity(this);
        return newKlient;
    }

    public loadFromJSON(json: any): Klient {
        this.id = json.id;
        this.jmeno = json.jmeno;
        this.prijmeni = json.prijmeni;
        this.telefon = json.telefon;
        this.email = json.email;
        this.ulice = json.ulice;
        this.mesto = json.mesto;
        this.poznamka = json.poznamka;
        this.PSC = json.PSC;
        this.stridavyRozvoz = json.stridavy_rozvoz;
        this.nahradniAdresa = json.nahradni_adresa;
        this.trasa = json.trasa;
        return this;
    }

    public loadFromEntity(ent: Klient): Klient {
        this.id = ent.id;
        this.jmeno = ent.jmeno;
        this.prijmeni = ent.prijmeni;
        this.telefon = ent.telefon;
        this.email = ent.email;
        this.ulice = ent.ulice;
        this.mesto = ent.mesto;
        this.poznamka = ent.poznamka;
        this.PSC = ent.PSC;
        this.stridavyRozvoz = ent.stridavyRozvoz;
        this.nahradniAdresa = ent.nahradniAdresa;
        this.trasa = ent.trasa;
        return this;
    }

    public getFullName(): string {
        return this.jmeno + ' ' + this.prijmeni;
    }

    public getFullAddress(): string {
        return this.ulice + ', ' + this.mesto + ', ' + this.PSC;
    }
}

export default Klient;


// WEBPACK FOOTER //
// ./src/models/Klient.tsx